/**
 * 描述：比较两个app version 大小， a > b 返回 1. a = b 返回 0. a < b 返回 -1.
 * 参数：
 * a - (Str) 要比较的版本号
 * b - (Str) 要比较的版本号
 **/
const appVersionCompare = (a: string, b: string): number => {
  const cmps = a.split('.');
  const tars = b.split('.');

  for (let i = 0; i < cmps.length && i < tars.length; i++) {
    const cmp = Number(cmps[i]);
    const tar = Number(tars[i]);

    if (cmp > tar) {
      return 1;
    } else if (cmp < tar) {
      return -1;
    }
  }

  if (cmps.length > tars.length) {
    return 1;
  } else if (cmps.length < tars.length) {
    return -1;
  }

  return 0;
};

export default appVersionCompare;
